<template>
  <div class="main">
    <div id="header">
      <Headerbar />
      <Sidebar
        @fontBig="changeFontBig"
        @fontMiddle="changeFontMiddle"
        @fontSmall="changeFontSmall"
      />

      <Banner />
    </div>
    <div id="Content">
      <a id="main" href="#main" accesskey="C" title="網頁內容區塊資訊"
        >:::</a
      >
      <div class="bread" v-show="!isHome">
        <BreadCrumb />
      </div>
      <router-view />
    </div>
    <div id="footer">
      <FooterTop />
      <FooterBottom />
    </div>
    <div>
      <GoToTop />
    </div>
  </div>
</template>

<script>
import { provide, ref, reactive, watch } from "vue";
import { useRoute } from "vue-router";
import UIkit from "uikit";
import Icons from "uikit/dist/js/uikit-icons";
UIkit.use(Icons);

import Headerbar from "./components/Home/Headerbar2.vue";
import Sidebar from "./components/Home/Sidebar2.vue";
import Banner from "./components/Home/Banner.vue";
import FooterTop from "./components/Home/FooterTop.vue";
import FooterBottom from "./components/Home/FooterBottom.vue";
import GoToTop from "./components/Home/GoToTop.vue";
import BreadCrumb from "@/components/Breadcrumb.vue";

export default {
  name: "App",
  components: {
    GoToTop,
    Headerbar,
    Banner,
    Sidebar,
    FooterTop,
    FooterBottom,
    BreadCrumb,
  },
  setup() {
    //  無障礙文字設定
    const fontSize = reactive({
      p: 1.125,
      h3: 1.688,
      h4: 1.375,
      h5: 1.25,
    });
    //  無障礙大文字設定
    function changeFontBig() {
      fontSize.p = 1.25;
      fontSize.h3 = 1.813;
      fontSize.h4 = 1.5;
      fontSize.h5 = 1.375;
    }
    //  無障礙中文字設定
    function changeFontMiddle() {
      fontSize.p = 1.125;
      fontSize.h3 = 1.688;
      fontSize.h4 = 1.375;
      fontSize.h5 = 1.25;
    }
    //  無障礙小文字設定
    function changeFontSmall() {
      fontSize.p = 1;
      fontSize.h3 = 1.563;
      fontSize.h4 = 1.25;
      fontSize.h5 = 1.125;
    }
    //  無障礙文字傳遞到子層設定
    provide("fontSize", fontSize);

    const route = useRoute();
    const isHome = ref();
    settingHomePage();

    // 判斷是否為首頁
    function settingHomePage() {
      isHome.value =
        route.path === "/index" || route.path === "/" ? true : false;
    }

    // 判斷麵包屑是否渲染
    watch(
      // 監聽route路徑，一有變更就更新麵包屑
      () => route.path,
      () => {
        //監聽 國家id的值
        settingHomePage();
      }
    );

    return {
      changeFontBig,
      changeFontMiddle,
      changeFontSmall,
      fontSize,
      isHome,
    };
  },
};
</script>

<style lang="scss">
@import "./assets/uikit/css/uikit.css";
.main {
  a {
    &:focus {
      outline: 2px dotted black;
    }
  }
  a:active, a:hover, a:focus {
    background: #ffbf47;
    color: #000;
    font-weight: 700;
}
  #Content {
    #main {
      display: table-caption;
    }
    width: 75%;
    margin: 0 auto;
    @include md {
      width: 90%;
      padding: 0;
    }
    .bread {
      display: flex;
      padding: 20px 0 10px;
      span {
        font-weight: 600;
      }
    }
  }
  .flag {
    width: 35px;
  }
}
</style>
